<template>
  <div class="hero">
    <div class="hero-content d-flex justify-content-center align-items-center">
      <h1>Árnyékguru Blog -  Hogyan válasszunk redőnyt? 🏘️</h1>
    </div>
  </div>
  <div class="blog-body">
    <h1 data-aos="fade-up"><i class="bi bi-brightness-high"></i> Mire figyeljünk, ha új redőnyt szeretnénk?</h1>

    <p data-aos="fade-up" data-aos-delay="100">
      A redőnyök rendkívül hasznos és praktikus eszközök a háztartásokban, amelyek nemcsak a napfény szabályozására,
      hanem a privát szféra védelmére, a hőmérséklet szabályozására és az energiatakarékosság növelésére is szolgálnak.
      Ahhoz, hogy hosszú távon hatékonyan és biztonságosan használjuk őket, fontos néhány szempontot figyelembe venni.
    </p>
    
    <img src="../../public/static/assets/blog/redony/kontener_redony.jpeg" alt="Veszprém redőnybeépítés" data-aos="zoom-in" data-aos-duration="600">
    
    <section>
      <h2><i class="bi bi-palette"></i> Anyag és minőség</h2>
      <ul>
        <li data-aos="fade-up" data-aos-delay="0">
          <strong><span class="badge-num">1</span>Műanyag</strong> 
          A műanyag redőny könnyű és megfizethető megoldás, ami sokak számára vonzó lehet.
          Ugyanakkor érzékenyebb az időjárás viszontagságaira, ezért idővel könnyebben kopik vagy sérülhet.
          Emellett nem alkalmas motoros működtetésre, így ha automatizálásra vágysz, más típusú redőnyt érdemes választani.
          <img src="../../public/static/assets/blog/redony/muanyag_redony.jpg" alt="Műanyag redőny Veszprém" data-aos="zoom-in" data-aos-duration="600">
        </li>
        <li data-aos="fade-up" data-aos-delay="100">
          <strong><span class="badge-num">2</span>Alumínium</strong> 
          Az alumínium redőnyök rendkívül tartósak és jól ellenállnak az időjárás viszontagságainak, így hosszú távon is megőrzik formájukat és működésüket.
          Emellett könnyen motorizálhatók, így egyszerűen automatizálhatók, ami nagy kényelmet biztosít a mindennapokban.
          <img src="../../public/static/assets/blog/redony/alu_redonylec.jpg" alt="Alumínium redőny Veszprém" data-aos="zoom-in" data-aos-duration="600">
        </li>
        <li data-aos="fade-up" data-aos-delay="200">
          <strong><span class="badge-num">3</span>Fa</strong> 
          A fa redőnyök természetes, meleg megjelenést biztosítanak, ugyanakkor rendszeres karbantartást igényelnek az időjárás hatásainak ellensúlyozására. 
          Ez az egyik legdrágább típus, de különleges stílust ad a lakásnak.
          <img src="../../public/static/assets/blog/redony/fa_redony.jpg" alt="Fa redőny Veszprém" data-aos="zoom-in" data-aos-duration="600">
          
        </li>
      </ul>
    </section>

    <section>
      <h2><i class="bi bi-sliders"></i> Redőny típusok</h2>
      <ul>
        <li data-aos="fade-up" data-aos-delay="0">
          <strong><span class="badge-num">1</span>Kézi működtetés:</strong>
          A kézi redőny gurtni segítségével működtethető, nem igényel áramot, egyszerű és hagyományos megoldás.
          <img src="../../public/static/assets/blog/redony/automata.jpg" alt="Balatonfüred gurtni csere" data-aos="zoom-in" data-aos-duration="600">
        </li>
        <li data-aos="fade-up" data-aos-delay="100">
          <strong><span class="badge-num">2</span>Elektromos redőnyök:</strong>
          Az elektromos redőny motorral működik, kényelmesen, akár telefonról is irányítható, programozható és automatikusan kezelhető.
          <img src="../../public/static/assets/blog/redony/taviranyitos_redony.jpg" alt="Balatonfüred elektromos redőny" data-aos="zoom-in" data-aos-duration="600">
        </li>
      </ul>
    </section>

    <section>
      <h2><i class="bi bi-lightning-fill"></i> Energiahatékonyság</h2>
      <p>A redőnyök jelentősen hozzájárulnak az energiafogyasztás csökkentéséhez, különösen a hideg és meleg évszakokban:</p>
      <ul>
        <li>
          <strong>Télen:</strong> 
          A redőnyök plusz szigetelőréteget képeznek az ablak előtt, így segítenek megtartani a lakás melegét, csökkentve a fűtési energiaigényt és ezzel a költségeket.
        </li>
        <li>
          <strong>Nyáron:</strong>
          Hatékonyan blokkolják a tűző napsugarakat, megakadályozva, hogy a nap felmelegítse a belső tereket, így hűvösebb és kellemesebb marad az otthon, csökkentve a légkondicionáló használatát és az ezzel járó energiaráfordítást.
        </li>
      </ul>
    </section>

    <section>
      <h2><i class="bi bi-tools"></i> Funkciók és kiegészítők</h2>
      <ul>
        <li><strong>Zajszigetelés:</strong> Hasznos forgalmas területeken.</li>
        <li><strong>Szúnyoghálók:</strong> Nyári kényelmet biztosítanak.</li>
      </ul>
    </section>

    <section>
      <h2><i class="bi bi-hammer"></i> Telepítés és karbantartás</h2>
      <p>
        A telepítés során fontos, hogy szakember végezze el a munkát, így garantált a termék megfelelő működése és a garancia megőrzése.
        Ezt követően a rendszeres karbantartás biztosítja a zavartalan működést és meghosszabbítja az eszköz élettartamát.
      </p>
    </section>

    <section>
      <h2><i class="bi bi-eye"></i> Esztétikai szempontok</h2>
      <p>Szín és kialakítás illesztése az épület stílusához.</p>
    </section>

    <section>
      <h2>Összegzés</h2>
      <p>
        A redőny hatékonyan szabályozza a lakás hőmérsékletét: nyáron kint tartja a hőséget, télen pedig csökkenti a hőveszteséget.
        Lehetővé teszi a fény mennyiségének pontos beállítását, akár teljes sötétítést is. Növeli a biztonságot, mert nehezebben hozzáférhetővé teszi az ablakot, és egyúttal védi a magánszférát, miközben mérsékli a kintről érkező zajt is.
      </p>
    </section>
    <img src="../../public/static/assets/blog/redony/vakito_feny.jpg" alt="Redőny telepítés Veszprém" data-aos="zoom-in" data-aos-duration="600">
    <div class="tip">
      <i class="bi bi-moon-stars"></i> Ha nyugodtan szeretnél aludni, válassz redőnyt — bennünk megbízhatsz, hogy a napfényt csak akkor engedjük be, amikor te szeretnéd!
    </div>
    <div class="d-flex justify-content-center">
      <PhoneComponent/>
    </div>
  </div>
</template>

<script>

import PhoneComponent from "@/components/PhoneComponent.vue";

export default {
  name: 'GurtniPage',
  data() {
    return {
    };
  },
  components: {
    PhoneComponent
  }
}

</script>

<style scoped lang="scss">
@use '@/assets/style/variables';
@use '@/assets/style/blog';

.header-placeholder {
  height: 65px;
}

.hero {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 500px;
}

.hero::before {
  content: "";
  position: absolute;
  top: 0px;
  left: 0;
  width: 100%;
  height: 100%;
  background: url(../../public/static/assets/blog/gurtni/hero.png);
  background-repeat: no-repeat;
  background-position: center bottom 25%;
  filter: brightness(80%);
  background-attachment: fixed;
  background-size: cover;
}

.hero-content {
  position: relative;
  color: variables.$light-color;
  padding: 20px;
}

@media screen and (max-width: 800px) {
  .hero {
    background: url(../../public/static/assets/blog/gurtni/hero.png);
    background-size: cover;
    height: 300px;
  }

  .hero::before {
    background: none !important;
  }

  .hero-content {
    position: relative;
    color: variables.$light-color;
    padding: 20px;
    background: #000;
    opacity: 0.5;
    width: 100%;
    height: 100%;
  }
}
</style>